var exports = {
  "u": "xfd349460--aa53f2--toggle-btn",
  "q": "xfd349460--aa53f2--toggle-btn--close",
};

module.exports = exports;
